import React from 'react';
import {
  GestureResponderEvent,
  ImageBackground,
  ImageSourcePropType,
  Platform,
  StyleSheet,
  Text,
  TouchableWithoutFeedback,
  View,
  ViewProps,
} from 'react-native-web';

import './SearchTile.module.scss';

export type SearchTileProps = {
  onPress?: () => void;
  source?: ImageSourcePropType;
  text?: string;
  className?: string;
  style?: ViewProps;
};

/**
 * Displays a clickable image with text beneath
 */
const SearchTile = ({
  onPress = () => {},
  source = null,
  text = '',
  className = '',
  style = undefined,
}: SearchTileProps) => {
  const handlePress = (event: GestureResponderEvent) => {
    // Prevent dialog from immediately being closed by click propagation
    event.preventDefault();
    event.stopPropagation();

    onPress();
  };

  return (
    <TouchableWithoutFeedback
      {...(Platform.OS === 'web'
        ? {
          // When scrolling the document body, the touchables might be triggered
          // see  https://github.com/necolas/react-native-web/issues/1219
          onClick: handlePress,
        }
        : {
          onPress: handlePress,
        })}
    >
      <View styleName="search-tile-wrapper" className={className} style={style}>
        <View styleName="image">
          <ImageBackground
            source={source}
            style={StyleSheet.absoluteFill}
          />
        </View>
        <View styleName="text-box">
          <Text styleName="text">{text}</Text>
        </View>
      </View>
    </TouchableWithoutFeedback>
  );
};

export default SearchTile;
